import {IOfferStageStatus} from "../detail/types/IOfferGroups";

export const getOfferStageText = (status: IOfferStageStatus) => {
    switch (status) {
        case IOfferStageStatus.IN_PREPARATION: {
            return "W przygotowaniu";
        }
        case IOfferStageStatus.ON_HOLD: {
            return "Wstrzymany";
        }
        case IOfferStageStatus.SOLD: {
            return "Sprzedany";
        }
        case IOfferStageStatus.FOR_SALE:
        default: {
            return "W sprzedaży";
        }
    }
};
import {IOfferStageStatus} from "../detail/types/IOfferGroups";

export const getOfferStageText = (status: IOfferStageStatus) => {
    switch (status) {
        case IOfferStageStatus.IN_PREPARATION: {
            return "W przygotowaniu";
        }
        case IOfferStageStatus.ON_HOLD: {
            return "Wstrzymany";
        }
        case IOfferStageStatus.SOLD: {
            return "Sprzedany";
        }
        case IOfferStageStatus.FOR_SALE:
        default: {
            return "W sprzedaży";
        }
    }
};
